export async function fetchJson(url: string, method: string, data?: any): Promise<Response> {
  const isGetMethod = method.toUpperCase() === "GET"
  const fetchOptions: RequestInit = {
    method: method.toUpperCase(),
    mode: "cors",
    headers: { "Content-Type": "application/json" },
    body: isGetMethod ? null : JSON.stringify(data),
  }

  if (isGetMethod && data) {
    url = generateGetUrl(url, data)
  }

  return await fetch(url, fetchOptions)
}

export async function fetchForm(url: string, method: string, data: any): Promise<Response> {
  const formData = new FormData()

  // 최상위 키 처리
  Object.entries(data).forEach(([key, value]) => {
    if (value instanceof File) {
      formData.append(key, value)
    } else if (value instanceof Array) {
      // 배열 처리, 배열 요소가 객체일 경우 추가적인 처리 수행
      value.forEach((item, index) => {
        if (item instanceof Object && !(item instanceof File)) {
          Object.entries(item).forEach(([subKey, subValue]) => {
            if (subValue instanceof File) {
              formData.append(`${key}[${index}][${subKey}]`, subValue)
            } else {
              formData.append(`${key}[${index}][${subKey}]`, subValue as string)
            }
          })
        } else {
          formData.append(`${key}[]`, item)
        }
      })
    } else if (value instanceof Object) {
      Object.entries(value).forEach(([subKey, subValue]) => {
        formData.append(`${key}[${subKey}]`, subValue)
      })
    } else {
      formData.append(key, value !== undefined || value !== null ? value as string : "")
    }
  })

  const accessToken = sessionStorage.getItem("accessToken")?.toString() || ""

  const fetchOptions: RequestInit = {
    method: method.toUpperCase(),
    mode: "cors",
    body: formData,
  }

  if (accessToken) {
    fetchOptions.headers = {
      Authorization: "Bearer " + sessionStorage.getItem("accessToken")?.toString() || "",
    }
  }

  return await fetch(url, fetchOptions)
}

function generateGetUrl(url: string, data?: any): string {
  const urlObj = new URL((url.startsWith("http") ? "" : window.location.origin) + url)
  const newSearchParams = new URLSearchParams()

  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((value) => newSearchParams.append(key, value.toString()))
    } else if (value !== undefined) {
      newSearchParams.append(key, (value as any).toString())
    }
  })

  return urlObj.toString() + (newSearchParams.size > 0 ? "?" + newSearchParams.toString() : "")
}

export async function downloadFile(url: string, data?: any, outputPath?: string) {
  try {
    url = generateGetUrl(url, data)
    const response = await fetch(url)

    if (!response.ok) {
      throw new Error(`Failed to download file. Status: ${response.status} ${response.statusText}`)
    }

    const blob = await response.blob()
    const link = document.createElement("a")
    link.href = URL.createObjectURL(blob)

    if (outputPath) {
      link.download = outputPath
    }

    document.body.appendChild(link)
    link.click()

    document.body.removeChild(link)
  } catch (error: any) {
    console.error("Error downloading file:", error.message)
    throw error
  }
}

export async function upload(url: string, method: string, data: any) {
  try {
    const formData = new FormData()

    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const element: any[] | string | Blob = data[key]

        if (element instanceof Array) {
          for (const item of element) {
            formData.append(key + "[]", item)
          }
        } else {
          formData.append(key, element)
        }
      }
    }

    const response = await fetch(url, {
      method: method,
      mode: "no-cors",
      body: formData,
    })

    return await response.json()
  } catch (error) {
    console.error("Error:", error)
  }
}
